import React from 'react';
import { MODALS } from '../../../../config/images';
const ModalWarning = ({ showModalWarning, closeModal, isContrato, daysLeft = null }) => {
  if (!showModalWarning) return null;

  let homologationText = `está por vencer`;

  let extraText = '';

  if (Number(daysLeft)) {
    if (daysLeft >= 0) {
      extraText = ` en ${daysLeft} días`
    } else {
      homologationText = ` venció hace`;
      extraText = ` ${Math.abs(daysLeft)} días`;
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
      <div className="lg:w-[33.33%] sm:w-[60%] w-[88%] h-auto bg-white rounded-3xl shadow-lg flex flex-col pb-4  ">
        <div className='flex justify-end'>
          <button
            onClick={closeModal}
            className="px-4 py-2 rounded-md"
          >
            <img src={MODALS.CLOSE} alt="cerrar"/>
          </button>
        </div>
        <div className='flex items-start justify-between gap-3 p-4 md:px-10 md:flex-row'>
            <img src={MODALS.WARNING} alt="warning"/>
            <div className='flex flex-col w-full'>
              <p className="text-xs md:text-sm font-itcdemi">
                {isContrato 
                    ? "Estimado proveedor su Contrato está por vencer, favor el apoyo con gestionarlo a la brevedad para que no haya inconvenientes en sus procesos." 
                    : `Estimado proveedor su Homologación ${homologationText}${extraText}, favor el apoyo con gestionarlo a la brevedad para que no haya inconvenientes en sus procesos financieros.`
                }
              </p>
              <p className='md:text-xs text-[10px] font-itcbook break-words'>
                Cualquier consulta comunicarse al correo:
                <br/>
                <span className='underline cursor-pointer'>operacionesdecompra@tasa.com.pe</span>
              </p>
            </div>
        </div>
      </div>
    </div>
  );
};
export default ModalWarning;
